import { TextButton } from '@wix/design-system';
import React from 'react';
export const CheckoutDisclaimerLink = _ref => {
  let {
    url,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    href: url,
    target: "_blank",
    size: "tiny"
  }, children);
};
//# sourceMappingURL=CheckoutDisclaimerLink.js.map